(function () {
  if (window.CompatibleEvData) return;

  const DEFAULT_COMPATIBLE_BRANDS = [
    {
      brand: "Tesla",
      pureEv: ["Model Y", "Model 3", "Model S", "Cybertruck"],
      phev: [],
    },
    {
      brand: "BYD",
      pureEv: ["Atto 1", "Dolphin", "Atto 2", "Atto 3", "Seal", "Sealion 7"],
      phev: ["Sealion 5", "Seal 6 Sedan", "Seal 6 Touring", "Sealion 6", "Shark 6", "Sealion 8"],
    },
    {
      brand: "Toyota",
      pureEv: ["bZ4X"],
      phev: ["RAV4 (PHEV)", "Prius (PHEV)"],
    },
    {
      brand: "Kia",
      pureEv: ["EV6", "EV5", "EV3", "Niro (EV)"],
      phev: ["Niro (PHEV)", "Sorento (PHEV)", "Sportage (PHEV)"],
    },
    {
      brand: "Hyundai",
      pureEv: ["Ioniq 5", "Ioniq 6", "Kona (EV)"],
      phev: ["Kona (PHEV)", "Tucson (PHEV)"],
    },
    {
      brand: "MG",
      pureEv: ["MG4", "ZS EV"],
      phev: ["HS (PHEV)"],
    },
    {
      brand: "Geely",
      pureEv: ["EX5", "EX2"],
      phev: ["Emgrand EM-i", "M9"],
    },
    {
      brand: "Polestar",
      pureEv: ["Polestar 2", "Polestar 3", "Polestar 4"],
      phev: [],
    },
    {
      brand: "GWM",
      pureEv: ["Ora"],
      phev: ["Haval Jolion (PHEV)", "Cannon Alpha (PHEV)"],
    },
    {
      brand: "Chery",
      pureEv: ["Omoda E5"],
      phev: ["Tiggo 4 (PHEV)", "Tiggo 7 (PHEV)"],
    },
    {
      brand: "Zeekr",
      pureEv: ["7X RWD", "7X Long Range", "7X Performance AWD", "7X Black Edition", "7GT (coming)"],
      phev: ["9X (coming)", "8X (coming)"],
    },
    {
      brand: "Volvo",
      pureEv: ["EX30", "EX90", "XC40 (EV)"],
      phev: ["XC40 (PHEV)", "XC60 (PHEV)", "XC90 (PHEV)"],
    },
    {
      brand: "Jaecoo",
      pureEv: ["J5"],
      phev: ["J8 PHEV (coming Q3 2026)"],
    },
    {
      brand: "BMW",
      pureEv: ["i4", "iX", "iX1", "iX3"],
      phev: ["X5 (PHEV)", "3 Series (PHEV)", "5 Series (PHEV)", "X3 (PHEV)"],
    },
    {
      brand: "Mercedes-Benz",
      pureEv: ["EQE", "EQS", "EQA", "EQB", "EQC", "EQV"],
      phev: ["GLC (PHEV)", "C-Class (PHEV)", "E-Class (PHEV)", "S-Class (PHEV)", "GLE (PHEV)"],
    },
    {
      brand: "Audi",
      pureEv: ["Q4 e-tron", "Q6 e-tron", "Q8 e-tron", "e-tron GT"],
      phev: ["A3 (PHEV)", "Q5 (PHEV)", "A6 (PHEV)"],
    },
    {
      brand: "Leapmotor",
      pureEv: ["C10", "B10", "B05", "B03X"],
      phev: ["C10 (EREV)", "B10 (EREV)"],
    },
  ];

  const storageKey = "chargehub-compatible-ev-models";

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function normalizeBrand(item) {
    return {
      brand: String(item.brand || "").trim(),
      logo: String(item.logo || "").trim(),
      pureEv: Array.isArray(item.pureEv) ? item.pureEv.map(String).filter(Boolean) : [],
      phev: Array.isArray(item.phev) ? item.phev.map(String).filter(Boolean) : [],
    };
  }

  function load() {
    if (Array.isArray(window.SHOPIFY_COMPATIBLE_EV_MODELS) && window.SHOPIFY_COMPATIBLE_EV_MODELS.length) {
      return window.SHOPIFY_COMPATIBLE_EV_MODELS.map(normalizeBrand).filter((item) => item.brand);
    }

    try {
      const stored = localStorage.getItem(storageKey);
      if (!stored) return clone(DEFAULT_COMPATIBLE_BRANDS);
      const parsed = JSON.parse(stored);
      if (!Array.isArray(parsed)) return clone(DEFAULT_COMPATIBLE_BRANDS);
      return parsed.map(normalizeBrand).filter((item) => item.brand);
    } catch {
      return clone(DEFAULT_COMPATIBLE_BRANDS);
    }
  }

  function save(data) {
    const normalized = data.map(normalizeBrand).filter((item) => item.brand);
    normalized.sort((a, b) => a.brand.localeCompare(b.brand));
    localStorage.setItem(storageKey, JSON.stringify(normalized));
    return normalized;
  }

  function reset() {
    localStorage.removeItem(storageKey);
    return clone(DEFAULT_COMPATIBLE_BRANDS);
  }

  window.CompatibleEvData = {
    storageKey,
    defaults: clone(DEFAULT_COMPATIBLE_BRANDS),
    load,
    save,
    reset,
  };
})();
